import { USER_ACCOUNT_SESSION_NAMESPACE } from 'assets/configurations/envConfigs';
import { createContext, useContext } from "react";


function helpers({ session = {} } = {}) {
    return {
        getLeapAccount: () => session[USER_ACCOUNT_SESSION_NAMESPACE]
    };
};

export const UserSession = createContext({
    getLeapAccount: () => undefined,
    updateSession: () => null,
    session: {}
});

export function useUserSession() {
    const state = useContext(UserSession);
    
    return { ...state, ...helpers(state) };
};